import { produce } from 'immer';

import { INTEGRATION_STUDIO_ACTION_TYPE } from '../actions/integrationStudio.actions';

const initialState = {
  providers: {},
  providersLoading: false,
  packages: {},
  methods: {},
  mappings: {},
  allowedHosts: {},
  runHistory: [],
  methodRunHistory: {},
  stats: null,
  packagesLoading: false,
  methodsLoading: false,
  mappingsLoading: false,
  runHistoryLoading: false,
  methodRunHistoryLoading: {},
  statsLoading: false,
  error: null,
};

const integrationStudioReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case INTEGRATION_STUDIO_ACTION_TYPE.GET_PROVIDERS_REQUEST:
        draft.providersLoading = true;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_PROVIDERS_SUCCESS:
        draft.providers = (payload || []).reduce((acc, provider) => {
          acc[provider.key] = provider;

          return acc;
        }, {});
        draft.providersLoading = false;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_PROVIDERS_FAILURE:
        draft.providersLoading = false;
        draft.error = payload;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.UPDATE_PROVIDER:
        draft.providers[payload.providerKey] = {
          ...draft.providers[payload.providerKey],
          ...payload.patch,
        };
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_STATS_REQUEST:
        draft.statsLoading = true;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_STATS_SUCCESS:
        draft.stats = payload || null;
        draft.statsLoading = false;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_STATS_FAILURE:
        draft.statsLoading = false;
        draft.error = payload;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_PACKAGES_REQUEST:
        draft.packagesLoading = true;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_PACKAGES_SUCCESS:
        draft.packages = payload.packages || {};
        draft.methods = { ...draft.methods, ...(payload.methods || {}) };
        draft.packagesLoading = false;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_PACKAGES_FAILURE:
        draft.packagesLoading = false;
        draft.error = payload;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_METHODS_REQUEST:
        draft.methodsLoading = true;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_METHODS_SUCCESS:
        draft.methods = { ...draft.methods, ...(payload || {}) };
        draft.methodsLoading = false;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_METHODS_FAILURE:
        draft.methodsLoading = false;
        draft.error = payload;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.CREATE_PACKAGE:
      case INTEGRATION_STUDIO_ACTION_TYPE.UPDATE_PACKAGE:
        if (payload) {
          Object.keys(payload).forEach(id => {
            draft.packages[id] = payload[id];
          });
        }

        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.DELETE_PACKAGE:
        delete draft.packages[meta.packageId];
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_METHOD:
      case INTEGRATION_STUDIO_ACTION_TYPE.CREATE_METHOD:
      case INTEGRATION_STUDIO_ACTION_TYPE.UPDATE_METHOD:
        if (payload) {
          Object.keys(payload).forEach(id => {
            draft.methods[id] = payload[id];
          });
        }

        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.DELETE_METHOD:
        delete draft.methods[meta.methodId];
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_MAPPINGS_REQUEST:
        draft.mappingsLoading = true;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_MAPPINGS_SUCCESS:
        draft.mappings[meta.methodId] = payload;
        draft.mappingsLoading = false;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_MAPPINGS_FAILURE:
        draft.mappingsLoading = false;
        draft.error = payload;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.SAVE_MAPPINGS:
        if (meta?.methodId) {
          draft.mappings[meta.methodId] = payload;
        }

        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_ALLOWED_HOSTS_SUCCESS:
        draft.allowedHosts[meta.packageId] = payload;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_RUN_HISTORY_REQUEST:
        draft.runHistoryLoading = true;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_RUN_HISTORY_SUCCESS:
        draft.runHistory = payload || [];
        draft.runHistoryLoading = false;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_RUN_HISTORY_FAILURE:
        draft.runHistoryLoading = false;
        draft.error = payload;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_METHOD_RUN_HISTORY_REQUEST:
        draft.methodRunHistoryLoading[meta.methodId] = true;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_METHOD_RUN_HISTORY_SUCCESS:
        draft.methodRunHistory[meta.methodId] = payload || [];
        draft.methodRunHistoryLoading[meta.methodId] = false;
        draft.error = null;
        break;

      case INTEGRATION_STUDIO_ACTION_TYPE.GET_METHOD_RUN_HISTORY_FAILURE:
        draft.methodRunHistoryLoading[meta.methodId] = false;
        draft.error = payload;
        break;

      default:
        return state;
    }
  });

export default integrationStudioReducer;
